import React from 'react'

import { Text } from '@wartek-id/text'
import { Shimmer } from '@wartek-id/shimmer'
import { Separator } from '@wartek-id/separator'

interface PanelSummaryItemProps {
  isLoading?: boolean
  label?: string
  value?: string
}

const PanelSummaryItem = ({
  isLoading = false,
  label,
  value,
}: PanelSummaryItemProps) => {
  return (
    <div className="flex items-center gap-2">
      {label && (
        <Text variant="subheading" color="subdued" className="uppercase">
          {label}
        </Text>
      )}

      {isLoading ? (
        <Shimmer />
      ) : (
        <>
          {!!value && (
            <Text
              variant="heading-sm"
              color="primary"
              className="uppercase"
              as="div"
            >
              {value}
            </Text>
          )}
        </>
      )}
    </div>
  )
}

interface PanelSummaryProps {
  isLoading?: boolean
  items?: {
    label: string
    value: any
  }[]
}

const PanelSummary = ({ isLoading = false, items }: PanelSummaryProps) => {
  return (
    <div
      className="bg-white rounded p-4 flex items-center tracking-wide gap-4"
      data-testid="panel-summary"
    >
      {items.map(({ label, value }, i) => (
        <React.Fragment key={`panel-summary-item-${i}`}>
          {i !== 0 && (
            <Separator
              orientation="vertical"
              className="!h-6"
              data-testid="separator"
            />
          )}
          <PanelSummaryItem label={label} value={value} isLoading={isLoading} />
        </React.Fragment>
      ))}
    </div>
  )
}

export default PanelSummary
